var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 2.29102C6.00358 2.29102 2.71668 5.33316 2.33 9.22777C2.2959 9.57126 1.9898 9.82206 1.64631 9.78796C1.30282 9.75385 1.05201 9.44775 1.08611 9.10427C1.53564 4.57666 5.35466 1.04102 10.0002 1.04102C13.6747 1.04102 16.8311 3.25318 18.2129 6.41578C18.3511 6.73209 18.2067 7.10054 17.8904 7.23874C17.5741 7.37694 17.2057 7.23255 17.0675 6.91625C15.8774 4.1925 13.1602 2.29102 10.0002 2.29102Z",
    fill: "#9897A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3336 1.87435C18.6788 1.87435 18.9586 2.15417 18.9586 2.49935V6.16602C18.9586 6.78734 18.4549 7.29102 17.8336 7.29102H14.1669C13.8217 7.29102 13.5419 7.01119 13.5419 6.66602C13.5419 6.32084 13.8217 6.04102 14.1669 6.04102H17.7086V2.49935C17.7086 2.15417 17.9884 1.87435 18.3336 1.87435Z",
    fill: "#9897A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0414 17.7077C14.0381 17.7077 17.325 14.6655 17.7116 10.7709C17.7457 10.4274 18.0518 10.1766 18.3953 10.2107C18.7388 10.2448 18.9896 10.5509 18.9555 10.8944C18.506 15.422 14.687 18.9577 10.0414 18.9577C6.36693 18.9577 3.21054 16.7455 1.82874 13.5829C1.69054 13.2666 1.83493 12.8982 2.15123 12.76C2.46753 12.6218 2.83598 12.7661 2.97418 13.0825C4.16424 15.8062 6.88145 17.7077 10.0414 17.7077Z",
    fill: "#9897A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70801 18.1243C1.36283 18.1243 1.08301 17.8445 1.08301 17.4993V13.8327C1.08301 13.2114 1.58669 12.7077 2.20801 12.7077H5.87467C6.21985 12.7077 6.49967 12.9875 6.49967 13.3327C6.49967 13.6779 6.21985 13.9577 5.87467 13.9577H2.33301V17.4993C2.33301 17.8445 2.05319 18.1243 1.70801 18.1243Z",
    fill: "#9897A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReGenerate);
export default __webpack_public_path__ + "static/media/re-generate.0a0e34fe9485f13ee91513ac2df2895e.svg";
export { ForwardRef as ReactComponent };